<div class="language-dropdown" ngbDropdown #ddLanguage="ngbDropdown">
  <button
    class="language-dropdown-btn rounded bg-secondary mx-3 btn p-0"
    id="languagedropdown"
    attr.aria-label="{{ 'nav.language.screenreader' | translate: { fgbdefault: 'Click for more language menu' } }}"
    ngbDropdownToggle
  >
    <div class="text-white font-size-12 text-center">{{ currentLanguage()?.label | translate }}</div>
  </button>
  <div
    ngbDropdownMenu
    (click)="closeDropDown(ddLanguage)"
    aria-labelledby="languagedropdown"
    class="shadow text-center py-3 language-dropdown-menu border-0"
  >
    <div class="d-flex justify-content-between align-items-center language-wrap-heading">
      <div class="d-flex align-items-center">
        <span class="material-icons font-size-22 me-2"> language </span>
        <span class="font-size-14 fw-bold language-heading">{{ 'fgbcl.language.selector.title' | translate }}</span>
      </div>
      <span class="material-icons cursor-pointer language-select-close-btn text-info"> close </span>
    </div>
    <hr class="mx-3 mt-2 mb-1" />
    <div class="row mx-0">
      @if (filteredLanguages?.length > 0) {
        @for (language of filteredLanguages; track language.lcid) {
          <div class="col-6 pt-2 text-end">
            <button
              (click)="useLanguage(language)"
              class="btn shadow btn-change-locale py-0"
              [ngClass]="{
                'bg-secondary text-white': currentLanguage()?.lcid === language.lcid,
                'bg-white': currentLanguage()?.lcid !== language.lcid,
              }"
              id="en-btn"
            >
              {{ 'language.selector.' + language.lang | translate }}
            </button>
          </div>
        }
      }
    </div>
  </div>
</div>
